import { useQuery } from "@tanstack/react-query";
import { shipmentsRepository } from "@/services";
import { useTenant } from "./useTenant";
import { STALE_TIMES } from "@/lib/queryConfig";

export interface Shipment {
  id: string;
  sale_id: string;
  tenant_id: string;
  melhor_envio_id: string | null;
  provider: string;
  provider_shipment_id: string | null;
  service_name: string | null;
  shipping_cost: number | null;
  tracking_code: string | null;
  label_url: string | null;
  status: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
}

export function useShipments(saleId: string | undefined) {
  const { tenant } = useTenant();

  return useQuery<Shipment[]>({
    queryKey: ["shipments", saleId, tenant?.id],
    queryFn: async () => {
      if (!saleId || !tenant?.id) return [];

      const { data, error } = await shipmentsRepository.listForSale(tenant.id, saleId);

      if (error) {
        throw error;
      }

      return data as Shipment[];
    },
    enabled: !!saleId && !!tenant?.id,
    staleTime: STALE_TIMES.STANDARD,
  });
}

export function useAllShipments() {
  const { tenant } = useTenant();

  return useQuery<Shipment[]>({
    queryKey: ["shipments", tenant?.id],
    queryFn: async () => {
      if (!tenant?.id) return [];

      const { data, error } = await shipmentsRepository.listAll(tenant.id);

      if (error) {
        throw error;
      }

      return data as Shipment[];
    },
    enabled: !!tenant?.id,
    staleTime: STALE_TIMES.STANDARD,
  });
}
